export default __webpack_public_path__ + "static/media/board.5568a93f.png";